module.exports = __webpack_public_path__ + "static/media/05_tvperu.6754e96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/05_tvperu.png
// module id = 536
// module chunks = 0